import _defineProperty from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import { usePropsValue } from '../../utils/use-props-value';
import { mergeProps } from '../../utils/with-default-props';
import { withNativeProps } from '../../utils/native-props';
import { withStopPropagation } from '../../utils/with-stop-propagation';
import { Arrow } from './arrow';
import { renderToContainer } from '../../utils/render-to-container';
import { arrow, computePosition, flip, offset, autoUpdate, hide, shift, limitShift } from '@floating-ui/dom';
import { Wrapper } from './wrapper';
import { useShouldRender } from '../../utils/should-render';
import { useClickAway, useIsomorphicLayoutEffect } from 'ahooks';
import { normalizePlacement } from './normalize-placement';
import { convertPx } from '../../utils/convert-px';
var classPrefix = "adm-popover";
var defaultProps = {
  placement: 'top',
  defaultVisible: false,
  stopPropagation: ['click'],
  getContainer: function getContainer() {
    return document.body;
  }
};
export var Popover = forwardRef(function (p, ref) {
  var props = mergeProps(defaultProps, p);
  var _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'light' : _props$mode;
  var placement = normalizePlacement(props.placement);

  var _usePropsValue = usePropsValue({
    value: props.visible,
    defaultValue: props.defaultVisible,
    onChange: props.onVisibleChange
  }),
      _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
      visible = _usePropsValue2[0],
      setVisible = _usePropsValue2[1];

  useImperativeHandle(ref, function () {
    return {
      show: function show() {
        return setVisible(true);
      },
      hide: function hide() {
        return setVisible(false);
      },
      visible: visible
    };
  }, [visible]);
  var targetRef = useRef(null);
  var floatingRef = useRef(null);
  var arrowRef = useRef(null);
  var floating = withStopPropagation(props.stopPropagation, withNativeProps(props, React.createElement("div", {
    className: classNames(classPrefix, "".concat(classPrefix, "-").concat(mode), !visible && "".concat(classPrefix, "-hidden")),
    ref: floatingRef
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-arrow"),
    ref: arrowRef
  }, React.createElement(Arrow, {
    className: "".concat(classPrefix, "-arrow-icon")
  })), React.createElement("div", {
    className: "".concat(classPrefix, "-inner")
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-inner-content")
  }, props.content)))));

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      targetElement = _useState2[0],
      setTargetElement = _useState2[1];

  function update() {
    var _a, _b, _c;

    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var target, floating, arrowElement, _yield$computePositio, x, y, realPlacement, middlewareData, side, arrowSide, _ref, arrowX, arrowY, arrowRotate;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              target = (_b = (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.element) !== null && _b !== void 0 ? _b : null;
              floating = floatingRef.current;
              arrowElement = arrowRef.current;
              setTargetElement(target);

              if (!(!target || !floating || !arrowElement)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return computePosition(target, floating, {
                placement: placement,
                middleware: [offset(convertPx(12)), shift({
                  padding: convertPx(4),
                  crossAxis: false,
                  limiter: limitShift()
                }), flip(), hide(), arrow({
                  element: arrowElement,
                  padding: convertPx(12)
                })]
              });

            case 8:
              _yield$computePositio = _context.sent;
              x = _yield$computePositio.x;
              y = _yield$computePositio.y;
              realPlacement = _yield$computePositio.placement;
              middlewareData = _yield$computePositio.middlewareData;
              Object.assign(floating.style, {
                left: "".concat(x, "px"),
                top: "".concat(y, "px")
              });
              side = realPlacement.split('-')[0];
              arrowSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right'
              }[side];
              _ref = (_c = middlewareData.arrow) !== null && _c !== void 0 ? _c : {}, arrowX = _ref.x, arrowY = _ref.y;
              Object.assign(arrowElement.style, _defineProperty({
                left: arrowX != null ? "".concat(arrowX, "px") : '',
                top: arrowY != null ? "".concat(arrowY, "px") : '',
                right: '',
                bottom: ''
              }, arrowSide, "-".concat(convertPx(8), "px")));
              arrowRotate = {
                top: '0deg',
                bottom: '180deg',
                left: '270deg',
                right: '90deg'
              }[side];
              arrowElement.style.setProperty('--arrow-icon-rotate', arrowRotate);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }

  useIsomorphicLayoutEffect(function () {
    update();
  });
  useEffect(function () {
    if (!targetElement) return;
    if (!props.trigger) return;

    function handleClick() {
      setVisible(function (v) {
        return !v;
      });
    }

    targetElement.addEventListener('click', handleClick);
    return function () {
      targetElement.removeEventListener('click', handleClick);
    };
  }, [targetElement, props.trigger]);
  useEffect(function () {
    var floatingElement = floatingRef.current;
    if (!targetElement || !floatingElement) return;
    return autoUpdate(targetElement, floatingElement, update, {
      elementResize: typeof ResizeObserver !== 'undefined'
    });
  }, [targetElement]);
  useClickAway(function () {
    if (!props.trigger) return;
    setVisible(false);
  }, function () {
    var _a;

    return (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.element;
  });
  var shouldRender = useShouldRender(visible, false, props.destroyOnHide);
  return React.createElement(React.Fragment, null, React.createElement(Wrapper, {
    ref: targetRef
  }, props.children), shouldRender && renderToContainer(props.getContainer, floating));
});